import type { ElementType, PropsWithChildren } from "react";

type ProvidersType = [ElementType, object | Record<string, unknown>];
type ChildrenType = PropsWithChildren;

const initialComponent = ({ children }: ChildrenType) => children;

/* eslint-disable react/display-name, react/jsx-props-no-spreading, max-params  -- these don't apply here*/
// eslint-disable-next-line sonarjs/function-return-type -- currently reported in SonarQube as unresolved
const buildProvidersTree = (componentsWithProps: ProvidersType[]) => {
  return componentsWithProps.reduce(
    (
      AccumulatedComponents: ElementType,
      [Provider, props = {}]: ProvidersType,
    ) => {
      return ({ children }: ChildrenType) => {
        return (
          <AccumulatedComponents>
            <Provider {...props}>{children}</Provider>
          </AccumulatedComponents>
        );
      };
    },
    initialComponent,
  );
};
/* eslint-enable react/display-name, react/jsx-props-no-spreading, max-params */

export { buildProvidersTree };
export type { ProvidersType };
